import { ProfileSection } from "@themes/pollinator/ui/ProfileSection";
import { ProfileAffiliationItem } from "./ProfileAffiliationItem";

export type Affiliation = {
  /** Unique identifier */
  id: number | string;
  /** Organization name */
  organizationName: string;
  /** Role/title within the organization (optional) */
  role?: string;
};

export type Props = {
  /** List of affiliations */
  affiliations: Affiliation[];
  /** Section label (default: "Affiliations") */
  label?: string;
  /** Test ID */
  "data-testid"?: string;
};

/**
 * List of profile affiliations showing organization name and role.
 */
export function ProfileAffiliationList({
  affiliations,
  label = "Affiliations",
  "data-testid": testId,
}: Props) {
  if (affiliations.length === 0) {
    return null;
  }

  return (
    <ProfileSection label={label} gap={4} data-testid={testId}>
      <div className="flex flex-col gap-2">
        {affiliations.map((affiliation) => (
          <ProfileAffiliationItem
            key={affiliation.id}
            organizationName={affiliation.organizationName}
            role={affiliation.role}
            data-testid={
              testId
                ? `${testId}-item-${affiliation.id}`
                : `affiliation-${affiliation.id}`
            }
          />
        ))}
      </div>
    </ProfileSection>
  );
}

export default ProfileAffiliationList;
